import api from './api';

const auditLogService = {
  getAllAuditLogs: (params = {}) => {
    // Извличаме всички параметри
    const {
      page = 0,
      size = 20,
      sortBy = 'performedAt',
      sortDirection = 'desc',
      chitalishteId,
      feedbackId,
      entityType,
      action,
      performedBy,
      startDate,
      endDate,
      ...otherParams
    } = params;

    // Подготвяме параметрите за заявката
    const queryParams = {
      page: page,
      size: size,
      sort: `${sortBy},${sortDirection}`,
      ...(chitalishteId && { chitalishteId: chitalishteId }),
      ...(feedbackId && { feedbackId: feedbackId }),
      ...(entityType && { entityType: entityType }),
      ...(action && { action: action }),
      ...(performedBy && { performedBy: performedBy }),
      ...(startDate && { startDate: startDate }),
      ...(endDate && { endDate: endDate }),
    };

    // Премахваме празни стойности
    Object.keys(queryParams).forEach(key => {
      if (queryParams[key] === '' || queryParams[key] === null || queryParams[key] === undefined) {
        delete queryParams[key];
      }
    });

    return api.get('/admin/audit-logs', { params: queryParams });
  },

  getAuditLogsByChitalishte: (chitalishteId, page = 0, size = 20) => {
    return api.get(`/admin/audit-logs/chitalishte/${chitalishteId}`, {
      params: { 
        page: page, 
        size: size, 
        sort: 'performedAt,desc' 
      }
    });
  },

  getAuditLogsByFeedback: (feedbackId, page = 0, size = 20) => {
    return api.get(`/admin/audit-logs/feedback/${feedbackId}`, {
      params: { 
        page: page, 
        size: size, 
        sort: 'performedAt,desc' 
      }
    });
  },

  getAuditLogsByChitalishteWithFeedback: (chitalishteId, page = 0, size = 20) => {
    return api.get(`/admin/audit-logs/chitalishte/${chitalishteId}/with-feedback`, {
      params: { 
        page: page, 
        size: size, 
        sort: 'performedAt,desc' 
      }
    });
  },

  searchAuditLogsWithRelations: (filters = {}, page = 0, size = 20) => {
    const queryParams = {
      page: page,
      size: size,
      sort: 'performedAt,desc',
      ...filters
    };

    // Премахваме празни стойности
    Object.keys(queryParams).forEach(key => {
      if (queryParams[key] === '' || queryParams[key] === null || queryParams[key] === undefined) {
        delete queryParams[key];
      }
    });

    return api.get('/admin/audit-logs/search', { params: queryParams });
  },

  getAuditLogStats: (startDate = null, endDate = null) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    return api.get('/admin/audit-logs/stats', { params });
  },

  searchAuditLogs: (searchTerm, page = 0, size = 20) => {
    const params = {
      page: page,
      size: size,
      sort: 'performedAt,desc',
      ...(searchTerm ? { performedBy: searchTerm } : {})
    };

    return api.get('/admin/audit-logs', { params });
  },

  exportAuditLogsToExcel: (filters = {}) => {
    return api.get('/admin/audit-logs/export', {
      params: filters,
      responseType: 'blob'
    });
  }
};

export default auditLogService; 